import React from 'react';

const Logo = ({ size = 56 }) => {
  return (
    <div className="flex items-center gap-3">
      <svg width={size} height={size} viewBox="0 0 80 80" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
        {/* Cupping hand */}
        <path
          d="M14 48 C 14 60, 26 70, 40 70 C 54 70, 66 60, 66 48 L 64 48 C 64 58, 53 66, 40 66 C 27 66, 16 58, 16 48 Z"
          fill="#3a5232"
        />
        {/* Tree trunk - person silhouette */}
        <circle cx="40" cy="24" r="5" fill="#3a5232" />
        <path d="M37 28 L37 50 L43 50 L43 28 Z" fill="#3a5232" />
        {/* Tree leaves */}
        <ellipse cx="32" cy="20" rx="8" ry="6" fill="#7a8a4c" transform="rotate(-20 32 20)" />
        <ellipse cx="48" cy="20" rx="8" ry="6" fill="#7a8a4c" transform="rotate(20 48 20)" />
        <ellipse cx="40" cy="12" rx="9" ry="6" fill="#8fa05a" />
        <ellipse cx="28" cy="30" rx="6" ry="4" fill="#8fa05a" transform="rotate(-30 28 30)" />
        <ellipse cx="52" cy="30" rx="6" ry="4" fill="#8fa05a" transform="rotate(30 52 30)" />
      </svg>
      <div className="flex flex-col leading-none">
        <span className="font-serif text-2xl md:text-3xl text-[#2c3f25] tracking-tight">Natural care</span>
        <span className="text-[10px] md:text-[11px] tracking-[0.22em] text-[#5a6a4a] mt-1 uppercase">Nurturing Minds, Enriching Lives</span>
      </div>
    </div>
  );
};

export default Logo;
